// extracted by mini-css-extract-plugin
export default {"hotspot":"KioskLogoutGesture_hotspot__9ytQD"};